import { fetchApiPost } from "@/lib/api/utils";
import {
  OtcBaseContractLanguagePreviewRequestValidation,
  OtcLanguagePreviewRequestValidation,
  type OtcBaseContractLanguagePreviewRequest,
  type OtcLanguagePreviewData,
  type OtcLanguagePreviewRequest,
} from "@/lib/validation/otcLanguagePreview";

export function usePreviewOtcLanguage() {
  return async (request: OtcLanguagePreviewRequest) => {
    const parsed = OtcLanguagePreviewRequestValidation.parse(request);

    return fetchApiPost<OtcLanguagePreviewData>(
      "otc/language/preview",
      parsed,
    );
  };
}

export function usePreviewOtcBaseContractLanguage() {
  return async (request: OtcBaseContractLanguagePreviewRequest) => {
    const parsed =
      OtcBaseContractLanguagePreviewRequestValidation.parse(request);

    return fetchApiPost<OtcLanguagePreviewData>(
      "otc/language/contract/preview",
      parsed,
    );
  };
}
